/* eslint-disable  */

import { Animation, EventTracker } from '@devexpress/dx-react-chart';
import {
  ArgumentAxis,
  BarSeries,
  Chart,
  ValueAxis,
  Tooltip as DxTooltip,
} from '@devexpress/dx-react-chart-material-ui';
import { Tooltip } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { TooltipOverlay } from 'components';
import Info from '@material-ui/icons/InfoOutlined';
import React from 'react';
import useStyles from './style';
import { IDailyBulletinChartProps, ITooltipContentProps } from './types';

const ChartDailyBulletin = ({ data, total }: IDailyBulletinChartProps) => {
  const classes = useStyles();

  const pallet = React.useMemo(() => data.map(item => item.color), [data]);

  const PointComponent = React.useCallback(
    ({ ...props }) => {
      if (props.value) {
        // const labelInPercent = `${((Number(props.value) / total) * 100).toFixed(
        //   0,
        // )}%`;
        return (
          <>
            <BarSeries.Point {...props} color={pallet[props.index]} />
          </>
        );
      }
      return <BarSeries.Point {...props} />;
    },
    [classes.barLabel, pallet, total],
  );

  //   <Chart.Label
  //   // O gráfico provê uma função para retornar o ponto de Y e X. Subtraindo/Somando um valor em px para afastar/aproximar a label da barra
  //   y={
  //     props.value
  //       ? props.scales.valScale(props.value) - 10
  //       : props.arg
  //   }
  //   x={props.arg}
  //   textAnchor="middle"
  //   className={classes.barLabel}
  // >
  //   {/* {labelInPercent} */}
  // </Chart.Label>

  const axiosLabelComponent = React.useCallback(
    (props: ArgumentAxis.LabelProps) => {
      return (
        <Tooltip title={props.text}>
          <ArgumentAxis.Label className={classes.labelItem} {...props} />
        </Tooltip>
      );
    },
    [classes.labelItem],
  );

  const TooltipContent = ({ targetItem, ...props }: ITooltipContentProps) => {
    const { point } = targetItem;
    const { maintenenceType, total: serieTotal } = data[point];

    const message = `${maintenenceType}: ${serieTotal};`;

    return (
      <DxTooltip.Content {...props} targetItem={targetItem} text={message} />
    );
  };

  if (!data || total <= 0) {
    return (
      <div className={classes.noData}>
        <Info />
        <p>Sem dados disponíveis</p>
      </div>
    );
  }

  return (
    <>
      <Paper className={classes.dailyChart}>
        <strong className={classes.subTitle}>Preventivas x Corretivas</strong>
        <Chart data={data} height={80} width={370} rotated>
          <ArgumentAxis labelComponent={axiosLabelComponent} />
          <ValueAxis showGrid={false} showLine={false} showLabels={false} />
          <BarSeries
            valueField="total"
            argumentField="maintenenceType"
            pointComponent={PointComponent}
          />
          <Animation />
          <EventTracker />

          <DxTooltip
            overlayComponent={TooltipOverlay}
            contentComponent={TooltipContent}
          />
        </Chart>
      </Paper>
    </>
  );
};

export default ChartDailyBulletin;
